export default __webpack_public_path__ + "static/IN-8015v6012_resTestBig-d95a82b6189e9792fa06de71131def57.webp";